
<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" :class="styling" aria-label="Company">
      <path d="M10.858 1.558 1.7.167A1.477 1.477 0 0 0 .517.492 1.49 1.49 0 0 0 0 1.608v17.559c0 .458.375.833.833.833h2.709v-4.375c0-.808.65-1.458 1.458-1.458h2.083c.809 0 1.459.65 1.459 1.458V20h3.541V3a1.46 1.46 0 0 0-1.225-1.442zM4.583 12.292h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm4.167 7.5H7.5a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5H7.5a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5H7.5a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5H7.5a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm10.1 4.243-5.933-1.242V20h5.625A1.46 1.46 0 0 0 20 18.542V10.46c0-.688-.47-1.274-1.15-1.425zM16.875 17.5h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25zm0-2.5h-1.25a.625.625 0 0 1 0-1.25h1.25a.625.625 0 0 1 0 1.25z" fill="currentColor"/>
    </svg>
  </div>
</template>

<script>
export default {

  props: {
    styling: {
      type: String,
      default: 'w-5 h-auto'
    }
  }

}
</script>